<template>
    <a-card>
        <div class="title">
            <h3>投资人基本信息</h3>
<!--            <span><ExclamationCircleOutlined/>审核通过</span>-->
            <!-- <span v-if="this.form.examine == null">
                <ExclamationCircleOutlined/>提交申请
            </span>
            <span :class="getClass(this.form.examine)" v-else>
                <ExclamationCircleOutlined/>{{COMMON_VARIABLE.approvalState[this.form.examine]}}
            </span> -->

        </div>
        <div class="border-t">
            <a-form ref="ruleForm" :model="form" :rules="rules" class="inline-form mt-15" @submit="onSubmit">
                <!--可编辑区域 start-->
              <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" />
                </a-form-item>
            </div>
            <table class="my-table">
                <tbody>
                    <tr>
                        <td colspan="24">
                            <a-form-item label="投资人头像" name="headImg">
                                    <img-upload v-model:value="form.headImg" />
                            </a-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="12">
                            <a-form-item label="投资人姓名" name="investorName">
                                    <a-input v-model:value="form.investorName" placeholder="请输入投资人姓名" />
                            </a-form-item>
                        </td>

                        <td colspan="12">
                            <a-form-item label="联系电话" name="contactNumber">
                                <a-input v-model:value="form.contactNumber" placeholder="请输入联系电话" />
                            </a-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="12">
                            <a-form-item label="身份证号码" name="investorCard">
                                <a-input v-model:value="form.investorCard" placeholder="请输入身份证号码" />
                            </a-form-item>
                        </td>
                        <td colspan="12">
                            <a-form-item label="投资领域" name="investmentField">
                                <multiple-select v-model:value="form.investmentField" :options="options.investmentfield" title-name="name" value-name="id"/>
                            </a-form-item>
                        </td>

                    </tr>
                    <tr>
                        <td colspan="12">
                            <a-form-item label="地区" name="prov">
                                <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
                                    placeholder="请选择省/市/区" />
                            </a-form-item>
                        </td>
                        <td colspan="12">
                            <a-form-item label="详细地址" name="address">
                                <a-input v-model:value="form.address" placeholder="请输入详细地址" />
                            </a-form-item>
                        </td>
                        
                    </tr>
                    <tr>
                        <td colspan="12">
                            <a-form-item label="职位" name="position">
                                <multiple-select v-model:value="form.position" :options="options.position" title-name="name" value-name="id"/>
                            </a-form-item>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="24">
                            <a-form-item label="投资人简介" name="introduction">
                                
                                <a-textarea v-model:value="form.introduction" placeholder="请输入投资人简介"
                                    :auto-size="{ minRows: 5, maxRows: 6 }" />
                            </a-form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="24">
                            <a-form-item label="投资案例" name="successCases">
                                
                                <a-textarea v-model:value="form.successCases" placeholder="请输入投资案例"
                                    :auto-size="{ minRows: 5, maxRows: 6 }" />
                            </a-form-item>
                        </td>
                    </tr>
                </tbody>
            </table>
                <div class='text-center mt-20' >
                    <a-button type="primary" @click="onSubmit">保存</a-button>
                </div>
                <!--可编辑区域 end-->
            </a-form>
        </div>
    </a-card>
</template>

<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {common_controller} from "@/api/commonService";
import { financeInvestor } from "@/api/finance";
import { financeDict } from "@/config/variableConfig";
// import {message} from "ant-design-vue";


export default {
    name: "index",
    components: {},
    mixins: [formMixin],
    data() {
        return {
            financeDict,
            options:[],
            form: {
              id: null,
              investorName: null,
              investorCard: null,
              position: null,
              contactNumber: null,
              email: null,
              introduction: null,
              prov: null,
              city: null,
              dist: null,
              address: null,
              headImg: null,
              investmentField: null,
              investmentAmount: null,
              investmentWay: null,
              investmentAddress: null,
              homePage: null,
              auditStatus: null,
              feedback: null,
              enabled: null,
              experience: null,
              successCases: null,
              views: null,
              keyWord: null,
              remark: null,
          },
          rules: {
              id:[],
              investorName: [dataCheck.required({})],
              investorCard: [dataCheck.required({})],
              position: [dataCheck.required({})],
              contactNumber: [dataCheck.required({})],
              email: [dataCheck.required({})],
              introduction: [dataCheck.required({})],
              prov: [dataCheck.required({})],
              city: [dataCheck.required({})],
              dist: [dataCheck.required({})],
              address: [dataCheck.required({})],
              headImg: [],
              investmentField: [dataCheck.required({})],
              investmentAmount: [dataCheck.required({})],
              investmentWay: [dataCheck.required({})],
              investmentAddress: [dataCheck.required({})],
              homePage: [dataCheck.required({})],
              auditStatus: [dataCheck.required({})],
              feedback: [dataCheck.required({})],
              enabled: [dataCheck.required({})],
              experience: [dataCheck.required({})],
              successCases: [dataCheck.required({})],
              views: [dataCheck.required({})],
              keyWord: [dataCheck.required({})],
              remark: [dataCheck.required({})],
          },
        }
    },
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeInvestor.edit
                } else {
                    return financeInvestor.add
                }
            }
        },
    mounted() {
        this.getDict();
        this.getCorpInfo()
    },
    methods: {
        getDict(){
            this.getAction({
                url:common_controller.getDictDataByGroupNumber,
                params: {
                    groupNumbers: "investmentfield,position"
                }
            }).then(res=>{
                this.options = res
            })
        },
        getCorpInfo() {
            this.getAction({
                url: financeInvestor.detail
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
.title {
    display: flex;
    border-bottom: 4px solid #000000;

    h3 {
        font-weight: bold;
    }

    span {
        font-size: 16px;
        margin-top: 4px;
        margin-left: 6px;
    }
}

.hide {
    display: none !important;
}

.border-t {
    border-width: 1px;
    border-style: solid;
    border-color: #dedede;
    border-width: 0;
    border-top-width: 1px;

    .inline-form {
        .ant-form-item {
            display: flex
        }

        .ant-form-item-control-wrapper {
            flex: 1;
        }
    }

    .my-table {
        table-layout: fixed;

        td {
            border: 1px solid #dedede;
            padding: 15px;
        }

        .ant-form-item {
            margin-bottom: 0;
        }
    }
}
.fc-blue{
    color: #409EFF;
}
.fc-green{
    color:#619c1b;
}
.fc-red{
    color:#ff3232;
}
</style>
